<template>
  <!-- eslint-disable vue/no-v-html -->
  <div>
    <div
      v-if="sidebar"
      class="form-title"
    >
      <span class="info-title">{{ info_title }}</span>
    </div>
    <div :class="[ confirmed ? 'display' : '', 'request-confirmation' ]">
      <p>{{ $t('messages.sent_to_email',{'email': email, 'brand_name': brand_name }) }}</p>

      <p>{{ $t('messages.questions') }} <a v-html="phoneLink()" /></p>
      <a
        class="btn close-btn"
        @click="closeConfirmation()"
      >{{ $t('messages.close') }}</a>
    </div>

    <div :class="[ confirmed ? '' : 'display', 'customer-request-form' ]">
      <div
        v-if="sidebar"
        class="form-instructions"
      >
        <div
          class="custom-travel"
          v-html="info"
        />
      </div>
      <form
        id="new_info_request"
        class="simple_form info_request"
        @submit="submitForm"
      >
        <input
          id="info_request_referring_page"
          value="/contact-us"
          type="hidden"
          name="referring_page"
        >
        <div class="column">
          <div
            class="form-group"
            :class="{'has-error': errors.has('first_name') }"
          >
            <input
              id="info_request_first_name"
              v-model="first_name"
              v-validate="'required'"
              class="form-control"
              :placeholder="$t('form.first_name')"
              type="text"
              name="first_name"
            >
            <label
              v-show="errors.has('first_name')"
              class="error"
              for="info_request_first_name"
            >{{ errors.first('first_name') }}</label>
          </div>
          <div
            class="form-group"
            :class="{'has-error': errors.has('last_name') }"
          >
            <input
              id="info_request_last_name"
              v-model="last_name"
              v-validate="'required'"
              class="form-control"
              :placeholder="$t('form.last_name')"
              type="text"
              name="last_name"
            >
            <label
              v-show="errors.has('last_name')"
              class="error"
              for="info_request_last_name"
            >{{ errors.first('last_name') }}</label>
          </div>
          <div
            class="form-group"
            :class="{'has-error': errors.has('email') }"
          >
            <input
              id="info_request_email"
              v-model="email"
              v-validate="'required|email'"
              class="form-control"
              :placeholder="$t('form.email')"
              type="email"
              name="email"
            >
            <label
              v-show="errors.has('email')"
              class="error"
              for="info_request_email"
            >{{ errors.first('email') }}</label>
          </div>
          <div id="hint" />
        </div>
        <div class="column">
          <div
            class="form-group"
            :class="{'has-error': errors.has('phone') }"
          >
            <input
              id="info_request_phone"
              v-model="phone"
              v-validate="'required|min:10'"
              class="form-control"
              :placeholder="$t('form.phone')"
              type="text"
              name="phone"
            >
            <label
              v-show="errors.has('phone')"
              class="error"
              for="info_request_phone"
            >{{ errors.first('phone') }}</label>
          </div>
          <div
            v-if="eventOptions.length > 1 || categoryOptions.length > 1"
            class="form-group"
          >
            <select
              id="info_request_event_id"
              v-model="event_id"
              v-validate="'required'"
              class="form-control select"
              name="event_id"
            >
              <template v-if="categoryOptions.length > 1">
                <option value="">
                  Event
                </option>
                <optgroup
                  v-for="category in categoryOptions"
                  :key="category.name"
                  :label="category.name"
                >
                  <option
                    v-for="option in category.events"
                    :key="option.id"
                    :value="option.id"
                  >
                    {{ option.label || option.display_name }}
                  </option>
                </optgroup>
              </template>
              <template v-else>
                <option
                  v-for="option in eventOptions"
                  :key="option.id"
                  :value="option.id"
                >
                  {{ option.label || option.display_name }}
                </option>
              </template>
            </select>
            <label
              v-show="errors.has('event_id')"
              class="error"
              for="info_request_event_id"
            >{{ errors.first('event_id') }}</label>
          </div>
          <div class="form-group">
            <select
              id="info_request_how_many"
              v-model="how_many"
              class="form-control"
              name="how_many"
            >
              <option
                v-for="option in howManyOptions"
                :key="option.value"
                :value="option.value"
              >
                {{ option.text }}
              </option>
            </select>
          </div>

          <div class="form-group boolean optional info_request_corporate_fields">
            <div class="checkbox">
              <label>
                <input
                  id="info_request_corporate_fields"
                  v-model="corporate_request"
                  class="boolean optional"
                  type="checkbox"
                  name="corporate_fields"
                >
                {{ $t('form.corporate') }}
                <span class="custom-checkbox" />
              </label>
            </div>
          </div>


          <div :class="[corporate_request ? 'display' : '', 'corporate_fields']">
            <div class="form-group string optional info_request_company_name">
              <input
                id="info_request_company_name"
                v-model="company_name"
                v-validate="corporate_request ? 'required' : ''"
                :disabled="corporate_request ? false : true"
                class="form-control string optional"
                :placeholder="$t('form.company_name')"
                type="text"
                name="company_name"
                autocomplete="off"
              >
              <label
                v-show="errors.has('company_name')"
                class="error"
                for="info_request_company_name"
              >{{ errors.first('company_name') }}</label>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="form-group">
            <textarea
              id="info_request_comments"
              v-model="comments"
              class="form-control"
              :placeholder="$t('form.comments')"
              maxlength="2000"
              name="comments"
            />
            <label
              v-show="comments.length >= 2000"
              class="error"
              for="info_request_comments"
            >2000 character max</label>
          </div>
          <div
            v-if="nba_info_request.isNbaForm"
            class="nba-info-request-consent"
          >
            <div
              class="form-group boolean required info_request_marketing_email_consent"
            >
              <div
                v-if="nba_info_request.isInsideUS"
                class="checkbox"
              >
                <label class="small-label">
                  <input
                    v-model="nba_info_request.nba_privacy_policy_consent"
                    class="boolean"
                    type="checkbox"
                    name="nba_privacy_policy"
                  >
                  <span class="custom-checkbox" />
                  <!-- eslint-disable-next-line vue/no-v-html -->
                  <span v-html="$t('form.nba_marketing_email_consent')" />
                </label>
              </div>
              <div
                v-else
                class="checkbox"
              >
                <label class="small-label">
                  <input
                    id="info_request_marketing_email_consent"
                    v-validate="'required'"
                    class="boolean required"
                    type="checkbox"
                    name="marketing_email_consent"
                  >
                  <span class="custom-checkbox" />
                  <!-- eslint-disable-next-line vue/no-v-html -->
                  <span v-html="'*' + $t('form.marketing_email_consent')" />
                  <template v-if="errors.has('marketing_email_consent')">
                    <br>
                    <strong
                      class="error"
                      for="info_request_marketing_email_consent"
                    >{{ errors.first('marketing_email_consent') }}</strong>
                  </template>
                </label>
              </div>
            </div>
            <p
              v-if="!nba_info_request.isInsideUS"
              class="nba-info-register show-nba-info"
              :class="nba_info_request.showNbaInfo ? 'hide-nba-info' : 'show-nba-info'"
              @click="nba_info_request.showNbaInfo = !nba_info_request.showNbaInfo"
            >
              <b>{{ $t('form.sign_up_for_nba_info') }}</b>
            </p>
            <div
              v-if="nba_info_request.showNbaInfo"
              class="form-group boolean"
            >
              <div class="checkbox">
                <label class="small-label">
                  <input
                    v-model="nba_info_request.nba_products_services_consent"
                    class="boolean"
                    name="nba_products_and_services"
                    type="checkbox"
                  >
                  <span class="custom-checkbox" />
                  <span>{{ $t('form.nba_products_services_consent') }}</span>
                </label>
                <div class="checkbox">
                  <label class="small-label">
                    <input
                      v-model="nba_info_request.nba_partners_consent"
                      class="boolean"
                      name="nba_partners"
                      type="checkbox"
                    >
                    <span class="custom-checkbox" />
                    <span>{{ $t('form.nba_partners_consent') }}</span>
                  </label>
                </div>
                <div class="checkbox">
                  <label class="small-label">
                    <input
                      v-model="nba_info_request.nba_privacy_policy_consent"
                      class="boolean"
                      name="nba_privacy_policy"
                      type="checkbox"
                    >
                    <span class="custom-checkbox" />
                    <span v-html="$t('form.nba_privacy_policy_consent')" />
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else-if="in_eu"
            class="form-group boolean required info_request_marketing_email_consent"
          >
            <div class="checkbox">
              <label>
                <input
                  id="info_request_marketing_email_consent"
                  v-validate="'required'"
                  class="boolean required"
                  type="checkbox"
                  name="marketing_email_consent"
                >
                <span class="custom-checkbox" />
                <span v-html="$t('form.marketing_email_consent')" />
                <template v-if="errors.has('marketing_email_consent')">
                  <br>
                  <strong
                    class="error"
                    for="info_request_marketing_email_consent"
                  >{{ errors.first('marketing_email_consent') }}</strong>
                </template>
              </label>
            </div>
          </div>
          <div class="clearfix">
            <input
              type="submit"
              name="commit"
              :value="$t('form.submit')"
              class="pull-right btn btn-secondary"
              data-ga-event-category="Info-Form"
              data-ga-event-action="Submit"
              :disabled="disabled"
            >
            <span v-if="processingError">{{ $t('submitFormError') }}</span>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
/* global locale ga pi */
import ScrollClass from '../../shared/scrolling_class'
import { trackPageView as gaTrackPageView } from '../analytics.js'
import { trackPageView as gtmTrackPageView } from '../google_tag_manager.js'

let sanitizeHtml = require('sanitize-html')
const sidebar_info = sanitizeHtml(window.sidebar_info, {
  allowedTags: ['span', 'a'],
  allowedAttributes: {
    'a': ['href', 'class', 'id']
  },
  allowedSchemesAppliedToAttributes: ['tel']
})

export default {

  // eslint-disable-next-line vue/require-prop-types
  props: ['instructions'],
  data() {
    return {
      stuff: {
        type: Array
      },
      show: true,
      comments: '',
      company_name: '',
      corporate_request: false,
      disabled: true,
      email: '',
      event_id: '',
      first_name: '',
      ga_id: {
        default: window.googleAnalyticsId,
        require: false,
        type: String
      },
      pardot_id: '',
      how_many: '',
      in_eu: false,
      nba_info_request: {
        isNbaForm: false,
        isInsideUS: false,
        showNbaInfo: false,
        nba_partners_consent: false,
        nba_products_services_consent: false,
        nba_privacy_policy_consent: false
      },
      last_name: '',
      phone: '',
      processingError: false,
      eventOptions: [{
        id: '',
        display_name: this.$t('form.event')
      }],
      categoryOptions: [],
      sidebar: true,
      brand_name: window.brand_name,
      info: sidebar_info,
      info_title: this.$t('request_packages'),
      confirmed: false,
      default_height: ''
    }
  },
  computed: {
    howManyOptions() {
      let options = [{ text: this.$t('form.how_many'), value: '' }]
      let i = 1
      while (i < 10) {
        options.push({ text: i, value: i })
        i++
      }
      options.push({ text: '10+', value: 10 })
      return options
    }
  },

  mounted() {
    this.setGaId()
    this.fetchEvents()
    this.phoneLink()
    this.isSidebar()
  },

  methods: {
    initEvents(body) {
      if (body.categories) {
        this.categoryOptions = body.categories
        for (let category of body.categories) {
          this.selectEvent(category.events)
        }
      } else if (body.events.length > 1) {
        this.eventOptions = this.eventOptions.concat(body.events)
        this.selectEvent(body.events)
      } else {
        this.event_id = body.events[0].id
      }
      this.disabled = false
    },
    fetchEvents: async function() {
      try {
        var package_page_type = document.getElementById('eventTypeDiv')
        var dropdown_url = `/api/info_requests/dropdown.json?locale=${locale}`
        if (package_page_type && package_page_type.getAttribute('data-event-type')){
          dropdown_url = dropdown_url +
          `&event_type=${package_page_type.getAttribute('data-event-type')}`
        }
        const response = await fetch(dropdown_url)
        const json = await response.json()
        this.in_eu = json.in_eu
        this.nba_info_request.isInsideUS = json.in_us
        this.initEvents(json)
        this.setNbaForm()
      }
      catch(error) {
        this.processingError = true
      }
    },
    formData() {
      if (this.nba_info_request.isNbaForm) {
        return {
          locale: locale,
          info_request: {
            event_id: this.event_id,
            comments: this.comments,
            corporate_request: this.corporate_request,
            company_name: this.corporate_request ? this.company_name : '',
            email: this.email,
            first_name: this.first_name,
            how_many: this.how_many,
            last_name: this.last_name,
            nba_partners_consent: this.nba_info_request.nba_partners_consent,
            nba_products_services_consent: this.nba_info_request.nba_products_services_consent,
            nba_privacy_policy_consent: this.nba_info_request.nba_privacy_policy_consent,
            pardot_id: this.pardotID(),
            phone: this.phone,
            ga_id: this.ga_id,
            referring_page: `${window.location.pathname}${window.location.search}`
          }
        }
      } else {
        return {
          locale: locale,
          info_request: {
            comments: this.comments,
            company_name: this.corporate_request ? this.company_name : '',
            corporate_request: this.corporate_request,
            email: this.email,
            event_id: this.event_id,
            first_name: this.first_name,
            ga_id: this.ga_id,
            how_many: this.how_many,
            last_name: this.last_name,
            pardot_id: this.pardotID(),
            phone: this.phone,
            referring_page: `${window.location.pathname}${window.location.search}`
          }
        }
      }
    },
    postFormData: async function () {
      try {
        const response = await fetch('/info_requests', {
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json'
          },
          method: 'POST',
          body: JSON.stringify(this.formData())
        })
        if(!response.ok) { throw 'Bad response' }
        this.disabled = false
        this.confirmed = true
        this.info_title = this.$t('messages.thank_you')
        gaTrackPageView('/info-request-thank-you')
        gtmTrackPageView(`https://${window.location.host}/info-request-thank-you`)
      } catch (error) {
        this.processingError = true
        this.disabled = false
      }
    },
    setNbaForm() {
      if (window.brand_name === 'NBA Premium') {
        this.nba_info_request.isNbaForm = true
        this.nba_info_request.nba_privacy_policy_consent = this.nba_info_request.isInsideUS ? true : false
      }
    },
    setGaId() {
      let tempGaId = ''
      if (typeof ga === 'function') {
        ga(function (tracker) {
          tempGaId = tracker.get('clientId')
        })
        this.ga_id = tempGaId
      }
    },
    pardotID() {
      try {
        return pi.tracker.visitor_id
      }
      catch(_) {
        null
      }
    },
    selectEvent(events) {
      for (let event of events) {
        if (event.path && window.location.pathname.includes(event.path)) {
          this.event_id = event.id
        }
      }
    },
    setDefaultHeight() {
      if (document.getElementById('sidebar') == null) {
        this.default_height = window.innerHeight + 1
      } else {
        this.default_height = document.getElementById('sidebar').clientHeight
      }
    },
    getMainHeight() {
      if (screen.width >= 1200) {
        this.setDefaultHeight()
        document.getElementsByTagName('main')[0].style.minHeight = this.default_height + 'px'
        ScrollClass.scrollToClass('request-confirmation')
      } else {
        ScrollClass.scrollToClass('form-title')
      }
    },
    submitForm(e) {
      e.preventDefault()
      this.$validator.validate().then(valid => {
        if (valid) {
          this.disabled = true
          this.getMainHeight()
          this.postFormData()
        } else {
          this.disabled = false
          // After submit, listen for changes on input
          for (let field of this.$validator.fields) {
            field.update({events: 'input|blur'})
          }
        }
      })
    },
    wipeData() {
      this.comments = ''
      this.corporate_request = false
      this.company_name = ''
      this.email = ''
      this.first_name = ''
      this.how_many = ''
      this.last_name = ''
      this.phone = ''
      this.$nextTick(() => this.$validator.reset())
    },
    closeConfirmation() {
      this.confirmed = false
      this.info_title = this.$t('request_packages')
      this.wipeData()
    },
    phoneLink() {
      var location = document.getElementById('country-code').dataset.code
      var phoneNumber = window.phone_numbers[location] || window.phone_numbers['default']
      return phoneNumber
    },
    isSidebar() {
      if($('.sidebar').length == 0 ) {
        this.sidebar = false
      }
    },
  }
}
</script>
